import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
import { Error } from '../Controls/Error';
import { required, maxLength, isWeakPassword, passwordsMatch } from "../Validators/";
import TextFormGroup from "../Controls/TextFormGroup";
import ValidationMessage from "../Controls/ValidationMessage";
 
import {
    updateOn,
    validateOn,
    mapProps,
    showErrors
} from "../Controls/ReactReduxFormSettings";

import { Provider } from 'react-redux';


const queryString = require('query-string');


@withRouter
export class Login extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        
        var queryStringParam = queryString.parse(this.props.location.search);

        this.state = { resetPasswordActive: false, resetPasswordToken: queryStringParam.PasswordResetToken };
        this.onLoginSubmit = this.onLoginSubmit.bind(this);
        this.onResetPasswordRequest = this.onResetPasswordRequest.bind(this);
        this.onResetPasswordSubmit = this.onResetPasswordSubmit.bind(this);
        this.onResetPassword = this.onResetPassword.bind(this);
        this.onResetPasswordComplete = this.onResetPasswordComplete.bind(this);
    }

    onLoginSubmit(form) {
        this.props.login(form.email, form.password, form.rememberMe);
    }

    onResetPasswordRequest(form) {
        this.props.resetPassword(form.email);
        this.onResetPasswordComplete();
    }
    onResetPasswordSubmit(form) {
        if(form.password === form.confirmPassword){
            this.props.resetPasswordUpdate(form.email, this.state.resetPasswordToken, form.password);
        }
        this.onResetPasswordComplete();
        this.props.history.push('/DiscussionBoard');
    }
    onResetPassword() {
        this.setState({resetPasswordToken: false, resetPasswordActive: true });
    }
    
    onResetPasswordComplete() {
        this.setState({resetPasswordToken: false, resetPasswordActive: false });
    }
    render() {
        const { location, children, ...props } = this.props;
        const {resetPasswordToken, resetPasswordActive} = this.state;

        let form = resetPasswordToken ?
        <div>
            <strong>RESET PASSWORD</strong>
            <LocalForm model="user" 
                validators={{
                    '': { passwordsMatch },
                  }}
                onSubmit={this.onResetPasswordSubmit.bind(this)} 
                getDispatch={(dispatch) => this.formDispatch = dispatch}
                >
                <div className="row">
                    <div className="col-12 mb-1">
                        <Control.text type="email" model=".email" placeholder="Email..." className="form-control"  
                        
                        component={TextFormGroup}
                        maxLength={255}
                        validators={{
                            required: required,
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        controlProps={{
                            validate: true
                        }}>
                            <Errors
                                model=".email"
                                messages={{
                                    required: "Valid email is required"
                                }}
                                show={showErrors}
                                component={ValidationMessage}
                            />
                        </Control.text>
                    </div>
                    <div className="col-12 mb-1">
                        <Control.text type="password" 
                        model=".password" 
                        placeholder="New Password..." 
                        className="form-control" 
                        component={TextFormGroup}
                        maxLength={255}
                        validators={{
                            isWeakPassword: isWeakPassword,
                            required: required,
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        controlProps={{
                            validate: true
                        }}
                        >
                        
                        <Errors
                            model=".password"
                            messages={{
                                isWeakPassword: "Weak password - use at least 8 characters"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.text>
                    </div>
                    <div className="col-12 mb-1">
                        <Control.text type="password" 
                            model=".confirmPassword" 
                            placeholder="Confirm Password..." 
                            className="form-control" 
                            component={TextFormGroup}
                            maxLength={255}
                            validators={{
                                isWeakPassword: isWeakPassword,
                                required: required,
                            }}
                            updateOn={updateOn}
                            validateOn={validateOn}
                            mapProps={mapProps}
                            controlProps={{
                                validate: true
                            }}
                        >
                        
                        <Errors
                            model=".confirmPassword"
                            messages={{
                                isWeakPassword: "Weak password - use at least 8 characters"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        
                        <Errors
                            model="user"
                            messages={{
                                passwordsMatch: "Passwords do not match"
                            }}
                        />
                        </Control.text>
                    </div>
                    <div  className="col-12 mb-1">
                    
                        <button type="submit" className="btn btn-primary btn-block">RESET</button>
                    </div>
                    <div  className="col-12 mb-1">
                        <a className="btn emphasis-link btn-block clickable" onClick={this.onResetPasswordComplete}><span className="small">cancel</span></a>
                    </div>
                </div>
                        
            </LocalForm>
        </div> 
        : resetPasswordActive ? <div>
            <strong>RESET PASSWORD</strong>
            <LocalForm model="user" 
                onSubmit={this.onResetPasswordRequest.bind(this)} 
                getDispatch={(dispatch) => this.formDispatch = dispatch}>
                <div className="row">
                    <div className="col-12 mb-1">
                        <Control.text type="email" model=".email" placeholder="Email..." className="form-control"  />
                    </div>
                    <div  className="col-12 mb-1">
                        <button type="submit" className="btn btn-primary btn-block">RESET</button>
                    </div>
                    <div  className="col-12 mb-1">
                        <a className="btn emphasis-link btn-block clickable" onClick={this.onResetPasswordComplete}><span className="small">cancel</span></a>
                    </div>
                </div>
            </LocalForm>
        </div> : 
        <div>
            <strong>LOGIN</strong>
            <LocalForm model="user" 
                onSubmit={this.onLoginSubmit.bind(this)} 
                getDispatch={(dispatch) => this.formDispatch = dispatch}>
                <div className="row">
                    <div className="col-12 mb-1">
                        <Control.text type="email" model=".email" placeholder="Email..." className="form-control"  />
                    </div>
                    <div className="col-12 mb-1">
                        <Control.text type="password" model=".password" placeholder="Password..." className="form-control" />
                    </div>
                    <div className="col-12 mb-1">
                        <Control.checkbox model=".rememberMe" /> Remember me
                    </div>
                    <div  className="col-12 mb-1">
                        <button type="submit" className="btn btn-primary btn-block">LOGIN</button>
                    </div>
                    <div  className="col-12 mb-1">
                        <a className="btn emphasis-link btn-block clickable" onClick={this.onResetPassword}><span className="small">forgot my password</span></a>
                    </div>
                </div>
                <Error {...this.props.error} />
            </LocalForm>
        </div>;
        return (<div className="row">
                    <div className="col-12 lightgrey-bg">
                        <div className="card lightgrey-bg ">
                            <div className="card-block col-10 push-1 col-md-4 push-md-4">
                                {form}
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Login.tsx